export const CSVExport = (data, fileName) => {
  // NOTE: Using application/csv instead of text/csv forces the OS to launch the
  // application that is registered to open csv files. This is primarily a fallback for
  // iOS which has weird bugs with the html5 link attribute 'download'.

  const exportData = new Blob([data]);
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(exportData, fileName);
  } else {
    const url = window.URL.createObjectURL(exportData);
    const link = document.createElement('a');
    // link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.href = url;
    link.download = fileName;
    link.click();
    //adding some delay in removing the dynamically created link solved the problem in FireFox
    setTimeout(() => {
      window.URL.revokeObjectURL(link);
    }, 0);
  }
};

export const PdfImageExport = (data, fileName, type) => {
  // NOTE: Using application/csv instead of text/csv forces the OS to launch the
  // application that is registered to open csv files. This is primarily a fallback for
  // iOS which has weird bugs with the html5 link attribute 'download'.

  const exportData = new Blob([data], {
    type: type
  });
  console.log(exportData);
  if (window.navigator.msSaveBlob) {
    console.log(data);
    window.navigator.msSaveBlob(exportData, fileName);
  } else {
    const url = window.URL.createObjectURL(exportData);
    const link = document.createElement('a');
    // link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.href = url;
    link.download = fileName;
    link.click();
    //adding some delay in removing the dynamically created link solved the problem in FireFox
    setTimeout(() => {
      window.URL.revokeObjectURL(link);
    }, 0);
  }
};



// WEBPACK FOOTER //
// ./src/utils/exports/exports.js